import { FC } from 'react'
import { DataSourceItem } from '../../../shipments-page'
import { Flex } from 'antd'
import RunShipment from './run-shipment/run-shipment'

interface IdProps {
    data: DataSourceItem
}

const Id: FC<IdProps> = ({ data }) => {
    return (
        <Flex justify={'space-between'}>
            <span>{data?.id}</span>

            <RunShipment data={data} />
        </Flex>
    )
}

export default Id
